import React, { Fragment, useState, FC } from "react";
// import { Popover, Transition } from "@headlessui/react";
import { FactsFeaturesDataType } from "data/types";
import Shopping from "images/Shopping.png";
import Supermarket from "images/Supermarket.png";
import Biking from "images/Biking.png";
import Parks from "images/Parks.png";



export interface StayDatesRangeInputProps {
    className?: string;
    defaultOpen?: boolean;
    facts?: FactsFeaturesDataType;
}

const Neighborhood: FC<StayDatesRangeInputProps> = ({
    className = "flex-1",
    defaultOpen = false,
    facts
}) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);
    const neighborhoods = ["Shopping", "Biking"];
    const neighborhoodImages = {
        Parks: Parks,
        Shopping: Shopping,
        Supermarket: Supermarket,
        Biking: Biking,
    } as Record<string, string>;

    function showFacts() {
        setIsOpen(!isOpen);

    }

    const renderDetail = () => {
        if (!isOpen) return null;
        return (
            <div className="grid grid-cols-3 gap-2 ">
                {neighborhoods.map((item, index) => (
                    <div key={index} className="m-[15px] flex items-center flex-col">
                        <div>
                            <img
                                src={neighborhoodImages[item]}
                                alt={item}
                                className="w-[70px] h-[70px] object-cover rounded-md"
                            />
                        </div>
                        <div >

                            <p className="p-[10px] text-center text-xs">
                                {item}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div
            className={`justify-center  relative overflow-hidden  transition-shadow  ${className}`}>
            <div className="flex flex-row w-full " onClick={showFacts} >
                <div className="my-[9px] text-left w-5/6" >
                    <span className="pl-[15px] block text-md font-semibold  flex items-center justify-left h-full">
                        Neighborhood
                    </span>
                </div>
                <div className={`flex  w-1/6 justify-end text-white ${isOpen ? "" : ""}`}>
                    <span className="flex rounded-tr-lg items-center justify-center w-[30px] bg-[#00D3DB] cursor-pointer rounded-bl-md">
                        {isOpen ? (
                            <i className=" text-xl font-bold las la-minus"></i>
                        ) : (
                            <i className="text-xl font-bold las la-plus"></i>
                        )}
                    </span>
                </div>

            </div>
            {renderDetail()}
        </div>
    );
};

export default Neighborhood;
